import React from 'react';
import Slider from 'react-slick';
import AbideLogos from '../../../components/AbideLogos';
import GeneralBtn from '../../../components/GeneralBtn';
import { BannerActivation } from '../../../utils/script';
import { StyledSliderArea2 } from './styles/StyledSliderArea2';

const SliderArea = ({ content }) => {
  return (
    <StyledSliderArea2>
      <div className="hero-slider-wrapper">
        <div className="hero-col-1">
          <div className="hero-text-group">
            <h1 className="hero-text-title animated">{content.heroContent.title}</h1>
            <p className="hero-text-description animated">
              {content.heroContent.description}
            </p>
            <GeneralBtn {...content.generalBtn} />
          </div>
          <AbideLogos content={content.abideLogos} />
        </div>
        <Slider {...BannerActivation} className="hero-col-2">
          {content.slickSlider.map((data, index) => {
            return (
              <div key={index} className="slick-content-wrapper">
                <div className="slick-single-content">
                  <div className="slick-border-lines-wrapper">
                    <div className="line-1"></div>
                    <div className="line-2"></div>
                  </div>
                  <div style={{ backgroundImage: `url(${data.image})` }} className="slider-image slick-content-image"></div>
                </div>
              </div>
            );
          })}
        </Slider>
      </div>
    </StyledSliderArea2>
  );
};

export default SliderArea;
